// Query keys centralizadas y jerárquicas del dominio user-profile.
// Invalidar todo con `userProfileKeys.all`; nunca escribir arrays de key
// inline en los hooks.
export const userProfileKeys = {
    all: ["userprofile"] as const,
    profile: () => [...userProfileKeys.all, "profile"] as const,
    fieldsMetadata: () => [...userProfileKeys.all, "fields-metadata"] as const,
} as const;
